import React, { useState } from 'react';
import { Box, Button, Flex, Icon, Text } from '@spothero/ui';
import IconCar from '@spothero/icons/car';
import XCircleFilled from '@spothero/icons/x-circle-filled';
import { useDispatch, useSelector } from 'react-redux';
import AddVehicleModal from 'pages/search-transient-event-monthly/components/add-vehicle';
import { getParkingType, getSearchVehicle } from 'store/selectors/selectors';
import { FilterCheckboxBase } from '../../../filter-bases';
import { isOversizedFeatureEnabled } from 'utils/search-vehicle';
import { setSearchVehicle } from 'store/search/search-actions';
import { SearchWidgetTooltip } from '@spothero/search-component';
import { TOOLTIPS, useTooltips } from 'pages/search/hooks/use-tooltips';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
const VehicleWrapper = ({ children }) => (<Flex justifyContent="flex-start" alignItems="center" gap="1">
        {children}
    </Flex>);
const VehicleName = ({ title, onClick, }) => (<VehicleWrapper>
        {title}
        <Button onClick={onClick} data-testid="filter-vehicle-clear" variant="tertiary">
            <Icon as={XCircleFilled} fill="black" height="4" width="4"/>
        </Button>
    </VehicleWrapper>);
const VehicleSelect = () => (<VehicleWrapper>
        <Icon as={IconCar} fill="black" height="4" width="4"/>
        <Text as="span" color="text.secondary.light" fontSize="inherit">
            Vehicle Type
        </Text>
    </VehicleWrapper>);
export const FilterVehicle = () => {
    const [isOpen, setIsOpen] = useState(false);
    const vehicle = useSelector((state) => getSearchVehicle(state));
    const storeState = useSelector((state) => state);
    const dispatch = useDispatch();
    const vehicleTitle = vehicle?.display_description || 'Not Listed';
    const parkingType = getParkingType(storeState);
    const isOversizedEnabled = isOversizedFeatureEnabled(parkingType);
    const { isVisible: isTooltipVisible, text: tooltipText, handleClose: handleTooltipClose, } = useTooltips(TOOLTIPS.search_vehicle_popover);
    const isMobile = useMobileBreakPoint();
    const clearVehicle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(setSearchVehicle(null));
    };
    const setIsOpenToTrue = () => setIsOpen(true);
    const setIsOpenToFalse = () => setIsOpen(false);
    return isOversizedEnabled ? (<Box sx={{
            '& .SearchWidgetTooltip': {
                zIndex: 1,
                top: {
                    base: 'calc(var(--chakra-space-desktop-search-header-height) - 16px)',
                    tablet: 16,
                },
                maxWidth: 'event-list-width-desktop',
            },
        }}>
            <FilterCheckboxBase testid="VehicleExtraFilter-add-vehicle-button" isActive={Boolean(vehicle)} onClick={setIsOpenToTrue}>
                {vehicle ? (<VehicleName title={vehicleTitle} onClick={clearVehicle}/>) : (<VehicleSelect />)}
                <AddVehicleModal isOpen={isOpen} onClose={setIsOpenToFalse} defaultVehicle={vehicle === null ? undefined : vehicle} // Element doesn't support null but is whats being passed in
    />
            </FilterCheckboxBase>
            {isTooltipVisible && !isMobile ? (<SearchWidgetTooltip text={tooltipText} onClose={handleTooltipClose}/>) : null}
        </Box>) : null;
};
